<template lang="pug">
  .component-proforma-to-credit-note
    ModalReveal(v-model="openReveal", @input="closeReveal")
      button.button(slot="trigger", @click="open") Make credit note
      .container
        .row
          .column
            label Refund on gateway
              input(type="checkbox" v-model="refund_on_gateway")
      ActionButton(:action="convertToCreditNote", :confirm="true" slot="footer") Make Credit note
</template>

<script>

import ActionButton from "../../ActionButton.vue";
import ModalReveal from "../../../foundation/ModalReveal.vue";
import KeplerBackofficeSdk from "../../../../../lib/kepler/backoffice";
import MaggieHelper from "../../../../../maggieHelper";

export default {
  name: 'ConvertProformaToCreditNote',
  components: {ModalReveal, ActionButton},
  data() {
    return {
      refund_on_gateway: false,
      openReveal: false
    }
  },
  methods: {
    closeReveal() {
      this.openReveal = false
    },
    open() {
      this.openReveal = true
    },
    convertToCreditNote() {
      return KeplerBackofficeSdk.invoices.select(this.invoice).convertToCreditNote({
        refund_on_gateway: this.refund_on_gateway
      }, (data) => {
        this.openReveal = false
        //this.$router.push({name: 'invoice', params: {id: data.id}})
        this.$router.go()
        MaggieHelper.notification('Completed', 'Credit note issued')
      })
    },
  },
  props: ['invoice']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ConvertProformaToCreditNote.vue?5af537c6